import { CommonEnums } from 'src/app/shared/common.enums';
export class Data_Cleanse_Inst {
    datacleanse_Inst_Id: number;
    nm: string;
    description: string;
    ver: string;
    valid_Cd: string;
    dxMp_Id: number;
    persistFlg: string;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    attr_Tab_Valid_Cd: string;

    constructor() {
        this.setDefaults()
    }

    setDefaults(): void {
        this.datacleanse_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.DEFAULT_VERSION_CODE;
        this.valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.persistFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.attr_Tab_Valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
    }

    static parse(datacleanse_InstTmp: Data_Cleanse_Inst): Data_Cleanse_Inst {
        let datacleanse_Inst: Data_Cleanse_Inst = new Data_Cleanse_Inst();
        datacleanse_Inst.copyFrom(datacleanse_InstTmp);
        return datacleanse_Inst;
    }

    gePrimaryKey(): string {
        return this.datacleanse_Inst_Id + '.' + this.dxMp_Id;
    }

    copy(): Data_Cleanse_Inst {
        let data_Cleanse_InstTmp: Data_Cleanse_Inst = new Data_Cleanse_Inst();

        data_Cleanse_InstTmp.datacleanse_Inst_Id = this.datacleanse_Inst_Id;
        data_Cleanse_InstTmp.nm = this.nm;
        data_Cleanse_InstTmp.description = this.description;
        data_Cleanse_InstTmp.ver = this.ver;
        data_Cleanse_InstTmp.valid_Cd = this.valid_Cd;
        data_Cleanse_InstTmp.dxMp_Id = this.dxMp_Id;
        data_Cleanse_InstTmp.updateBy = this.updateBy;
        data_Cleanse_InstTmp.lastUpdateBy = this.lastUpdateBy;
        data_Cleanse_InstTmp.updateDt = this.updateDt;
        data_Cleanse_InstTmp.persistFlg = this.persistFlg;
        data_Cleanse_InstTmp.attr_Tab_Valid_Cd = this.attr_Tab_Valid_Cd;

        return data_Cleanse_InstTmp;
    }

    copyFrom(data_Cleanse_InstTmp: Data_Cleanse_Inst): void {
        this.datacleanse_Inst_Id = data_Cleanse_InstTmp.datacleanse_Inst_Id;
        this.nm = data_Cleanse_InstTmp.nm;
        this.description = data_Cleanse_InstTmp.description;
        this.ver = data_Cleanse_InstTmp.ver;
        this.valid_Cd = data_Cleanse_InstTmp.valid_Cd;
        this.dxMp_Id = data_Cleanse_InstTmp.dxMp_Id;
        this.updateBy = data_Cleanse_InstTmp.updateBy;
        this.lastUpdateBy = data_Cleanse_InstTmp.lastUpdateBy;
        this.updateDt = data_Cleanse_InstTmp.updateDt;
        this.persistFlg = data_Cleanse_InstTmp.persistFlg;
        this.attr_Tab_Valid_Cd = data_Cleanse_InstTmp.attr_Tab_Valid_Cd;
    }

    compare(data_Cleanse_InstTmp: Data_Cleanse_Inst): string {
        let data_Cleanse_InstString: string = this.toString(false);
        let data_Cleanse_InstTmpString: string = data_Cleanse_InstTmp.toString(false);

        if (data_Cleanse_InstString != data_Cleanse_InstTmpString) {
            return data_Cleanse_InstString + ', ' + data_Cleanse_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "datacleanse_Inst [datacleanse_Inst=" + this.datacleanse_Inst_Id + ", nm=" + this.nm + ", description=" + this.description +
            ", valid_Cd=" + this.valid_Cd + ", dxMp_Id=" + this.dxMp_Id + ", persistFlg=" + this.persistFlg +
            ", attr_Tab_Valid_Cd=" + this.attr_Tab_Valid_Cd;

        if (isNotCompare) {
            str += ", ver=" + this.ver + ", updateBy=" + this.updateBy + ", lastUpdateBy=" + this.lastUpdateBy + ", updateDt=" + this.updateDt;
        }

        str += ']';
        return str;
    }
}